import { ErrorHandlerName, IErrorHandler } from '../Libs/xhr/ErrorHandler';
import { Constants } from './Constants';
import { AbsenceDataService, AbsenceDataServiceName } from './DataServices/AbsenceDataService';
import {
    AffairesDataService,
    AffairesDataServiceName,
    IAffairesDataService,
} from './DataServices/AffairesDataService';
import {
    AuthDataService,
    AuthDataServiceName,
    IAuthDataService,
} from './DataServices/AuthenticationDataService';
import {
    CauserieDataService,
    CauserieDataServiceName,
    ICauserieDataService,
} from './DataServices/CauserieDataService';
import { ClientDataService, ClientDataServiceName } from './DataServices/ClientDataService';
import {
    CompagnonDataService,
    CompagnonDataServiceName,
    ICompagnonDataService,
} from './DataServices/CompagnonDataService';
import {
    ControleTemplateDataService,
    ControleTemplateDataServiceName,
    IControleTemplateDataService,
} from './DataServices/ControleTemplateDataService';
import {
    ControlsDataService,
    ControlsDataServiceName,
    IControlsDataService,
} from './DataServices/ControlsDataService';
import {
    ControlTemplatesDataService,
    ControlTemplatesDataServiceName,
    IControlTemplatesDataService,
} from './DataServices/ControlTemplatesDataService';
import { EnginDataService, EnginDataServiceName } from './DataServices/EnginDataService';
import {
    FormationDataService,
    FormationDataServiceName,
} from './DataServices/FormationDataService';
import { MaterielDataService, MaterielDataServiceName } from './DataServices/MaterielDataService';
import { IMeDataService, MeDataService, MeDataServiceName } from './DataServices/MeDataService';
import {
    IMediaDataService,
    MediaDataService,
    MediaDataServiceName,
} from './DataServices/MediaDataService';
import {
    IMessageDataService,
    MessageDataService,
    MessageDataServiceName,
} from './DataServices/MessageDataService';
import { PlanningDataService, PlanningDataServiceName } from './DataServices/PlanningDataService';
import {
    IPointageDataService,
    PointageDataService,
    PointageDataServiceName,
} from './DataServices/PointageDataService';
import {
    IQualificationDataService,
    QualificationDataService,
    QualificationDataServiceName,
} from './DataServices/QualificationDataService';
import {
    ISharepointDataService,
    SharepointDataService,
    SharepointDataServiceName,
} from './DataServices/SharepointDataService';
import { VehiculeDataService, VehiculeDataServiceName } from './DataServices/VehiculeDataService';
import {
    VisiteMedicaleDataService,
    VisiteMedicaleDataServiceName,
} from './DataServices/VisiteMedicaleDataService';
import { DetamErrorHandler } from './Errors/DetamErrorHandler';
import { AbsenceService, AbsenceServiceName } from './Services/Data/Absence/AbsenceService';
import {
    AffairesService,
    AffairesServiceName,
    IAffairesService,
} from './Services/Data/Affaires/AffairesService';
import { initializeApiClient } from './Services/Data/Api/ApiService';
import {
    AuthService,
    AuthServiceName,
    IAuthService,
} from './Services/Data/Authentication/AuthenticationService';
import {
    CauserieService,
    CauserieServiceName,
    ICauserieService,
} from './Services/Data/Causerie/CauserieService';
import { ClientService, ClientServiceName } from './Services/Data/Clients/ClientService';
import {
    CompagnonService,
    CompagnonServiceName,
    ICompagnonService,
} from './Services/Data/Compagnon/CompagnonService';
import {
    ControleTemplateService,
    ControleTemplateServiceName,
    IControleTemplateService,
} from './Services/Data/Controles/ControleTemplateService';
import {
    ControlsService,
    ControlsServiceName,
    IControlsService,
} from './Services/Data/Controls/ControlsService';
import {
    DownloadService,
    DownloadServiceName,
    IDownloadService,
} from './Services/Data/Download/DownloadService';
import { EnginService, EnginServiceName } from './Services/Data/Engins/EnginService';
import { FormationService, FormationServiceName } from './Services/Data/Formation/FormationService';
import { I18nService, I18nServiceName, II18nService } from './Services/Data/I18n/I18nService';
import { MaterielService, MaterielServiceName } from './Services/Data/Materiels/MaterielService';
import { IMeService, MeService, MeServiceName } from './Services/Data/Me/MeService';
import {
    IMessageService,
    MessageService,
    MessageServiceName,
} from './Services/Data/Message/MessageService';
import {
    IPlanningService,
    PlanningService,
    PlanningServiceName,
} from './Services/Data/Planning/PlanningService';
import {
    IPointageService,
    PointageService,
    PointageServiceName,
} from './Services/Data/Pointage/PointageService';
import {
    IQualificationService,
    QualificationService,
    QualificationServiceName,
} from './Services/Data/Qualifications/QualificationService';
import {
    ISharepointService,
    SharepointService,
    SharepointServiceName,
} from './Services/Data/Sharepoint/SharepointService';
import { VehiculeService, VehiculeServiceName } from './Services/Data/Vehicules/VehiculeService';
import {
    VisiteMedicaleService,
    VisiteMedicaleServiceName,
} from './Services/Data/VisiteMedicale/VisiteMedicaleService';
import { DetamLogService, ILogService, LogServiceName } from './Services/DetamLogService';
import { IoC } from './Services/ServicesContainer';

export class CoreBootstrapper {
    //* Initialize second/later (services)
    public initializeCore = (): void => {
        const appErrorHandler = IoC.get<IErrorHandler>(ErrorHandlerName);

        //* Setup Api client
        const timeout = 1000 * 60; //* 1 minute;
        initializeApiClient(Constants.getRoot(), appErrorHandler, timeout);
    };

    //* Initialize first (services)
    protected initializeCoreServices = (): void => {
        //* Create and bind LogService
        const logService: ILogService = new DetamLogService();
        IoC.bind<ILogService>(LogServiceName, new DetamLogService());

        //* Create and bind I18nService
        const i18nService: II18nService = new I18nService();
        IoC.bind<II18nService>(I18nServiceName, i18nService);

        //* Create and bind App ErrorHandler
        IoC.bind<IErrorHandler>(ErrorHandlerName, new DetamErrorHandler(i18nService, logService));

        //* Register data services
        IoC.bind<IAuthDataService>(AuthDataServiceName, new AuthDataService());
        IoC.bind<IMediaDataService>(MediaDataServiceName, new MediaDataService());
        IoC.bind<IMeDataService>(MeDataServiceName, new MeDataService());
        IoC.bind<IAffairesDataService>(AffairesDataServiceName, new AffairesDataService());
        IoC.bind<IControlsDataService>(ControlsDataServiceName, new ControlsDataService());
        IoC.bind<ICompagnonDataService>(CompagnonDataServiceName, new CompagnonDataService());
        IoC.bind<IControlTemplatesDataService>(
            ControlTemplatesDataServiceName,
            new ControlTemplatesDataService()
        );
        IoC.bind<IPointageDataService>(PointageDataServiceName, new PointageDataService());
        IoC.bind<ICauserieDataService>(CauserieDataServiceName, new CauserieDataService());
        IoC.bind<ISharepointDataService>(SharepointDataServiceName, new SharepointDataService());
        IoC.bind<IMessageDataService>(MessageDataServiceName, new MessageDataService());
        IoC.bind<FormationDataService>(FormationDataServiceName, new FormationDataService());
        IoC.bind<IQualificationDataService>(
            QualificationDataServiceName,
            new QualificationDataService()
        );
        IoC.bind<VisiteMedicaleDataService>(
            VisiteMedicaleDataServiceName,
            new VisiteMedicaleDataService()
        );
        IoC.bind<AbsenceDataService>(AbsenceDataServiceName, new AbsenceDataService());
        IoC.bind<EnginDataService>(EnginDataServiceName, new EnginDataService());
        IoC.bind<MaterielDataService>(MaterielDataServiceName, new MaterielDataService());
        IoC.bind<ClientDataService>(ClientDataServiceName, new ClientDataService());
        IoC.bind<VehiculeDataService>(VehiculeDataServiceName, new VehiculeDataService());
        IoC.bind<PlanningDataService>(PlanningDataServiceName, new PlanningDataService());

        //* Register Redux services
        IoC.bind<IAuthService>(AuthServiceName, new AuthService());
        IoC.bind<IMeService>(MeServiceName, new MeService());
        IoC.bind<IAffairesService>(AffairesServiceName, new AffairesService());

        //* Controles template
        IoC.bind<IControleTemplateDataService>(
            ControleTemplateDataServiceName,
            new ControleTemplateDataService()
        );
        IoC.bind<IControleTemplateService>(
            ControleTemplateServiceName,
            new ControleTemplateService()
        );

        IoC.bind<IControlsService>(ControlsServiceName, new ControlsService());
        IoC.bind<ICompagnonService>(CompagnonServiceName, new CompagnonService());
        IoC.bind<IPointageService>(PointageServiceName, new PointageService());
        IoC.bind<ICauserieService>(CauserieServiceName, new CauserieService());
        IoC.bind<ISharepointService>(SharepointServiceName, new SharepointService());
        IoC.bind<IMessageService>(MessageServiceName, new MessageService());
        IoC.bind<IDownloadService>(DownloadServiceName, new DownloadService());
        IoC.bind<FormationService>(FormationServiceName, new FormationService());
        IoC.bind<IQualificationService>(QualificationServiceName, new QualificationService());
        IoC.bind<VisiteMedicaleService>(VisiteMedicaleServiceName, new VisiteMedicaleService());
        IoC.bind<AbsenceService>(AbsenceServiceName, new AbsenceService());
        IoC.bind<EnginService>(EnginServiceName, new EnginService());
        IoC.bind<MaterielService>(MaterielServiceName, new MaterielService());
        IoC.bind<ClientService>(ClientServiceName, new ClientService());
        IoC.bind<VehiculeService>(VehiculeServiceName, new VehiculeService());
        IoC.bind<IPlanningService>(PlanningServiceName, new PlanningService());
    };
}
